// extracted by mini-css-extract-plugin
module.exports = {"container":"MyMediaIcon_container__pH4Sz","group":"MyMediaIcon_group__8WVhK"};